/* ==========================================================================
   Karchir — ana sayfa davranışları

   Horizon'un hazır bölümlerinde olmayan, Pebble'da olan küçük davranışlar.
   Horizon'un kendi JavaScript'ine dokunmuyoruz; sadece hazır çıktının
   yanına ekleme yapıyoruz.

   1) Hero sayaç ilerleme çizgisi
      Horizon "1/2" sayacını çiziyor ama Pebble'daki ince ilerleme çizgisi yok.
      Sayacın yanına bir çizgi ekleyip, sayaç değiştikçe doluluğunu güncelliyoruz.
      Slayt sayısını ve sıradaki slaydı Horizon'un kendi işaretlerinden okuyoruz,
      böylece Horizon slaytı nasıl değiştirirse değiştirsin çizgi doğru kalıyor.
   ========================================================================== */

(function () {
  'use strict';

  var SINIF = 'karchir-ilerleme';
  // Slayt değişince metin animasyonu bu kadar bekliyor (slayt kayması otursun)
  var GECIS_GECIKME = 300;

  function toplamSlayt(sayac) {
    // Sayaç "1/2" biçiminde: bölü işaretinden sonrası toplam
    var metin = (sayac.textContent || '').replace(/\s+/g, '');
    var parca = metin.split('/');
    var n = parseInt(parca[parca.length - 1], 10);
    return isNaN(n) ? 0 : n;
  }

  function suankiSlayt(sayac) {
    var el = sayac.querySelector('[ref="current"]');
    var n = parseInt((el && el.textContent) || '1', 10);
    return isNaN(n) ? 1 : n;
  }

  function kaydiriciBul(el) {
    if (el.closest) {
      var k = el.closest('slideshow-component');
      if (k) return k;
    }
    var n = el.parentElement;
    while (n && n.tagName !== 'SLIDESHOW-COMPONENT') n = n.parentElement;
    return n;
  }

  // Slayt süresi: slideshow-component üzerinde autoplay="5" biçiminde duruyor
  function slaytSuresi(kaydirici) {
    if (!kaydirici) return 0;
    var sn = parseFloat(kaydirici.getAttribute('autoplay') || kaydirici.dataset.karchirSure);
    return isNaN(sn) || sn <= 0 ? 0 : sn;
  }

  // Çubuğu baştan doldurmaya başlat (animasyonu sıfırla)
  function yenidenBaslat(cizgi) {
    var dolgu = cizgi.firstElementChild;
    if (!dolgu) return;
    dolgu.style.animation = 'none';
    // Tarayıcıyı yeniden hesaplamaya zorla, yoksa animasyon sıfırlanmıyor
    void dolgu.offsetWidth;
    dolgu.style.animation = '';
    if (document.hidden || cizgi.dataset.karchirDur) dolgu.style.animationPlayState = 'paused';
  }

  // Otomatik geçiş yoksa çubuk kaç slaytta kaçıncı olduğumuzu gösterir
  function oranGuncelle(sayac, cizgi) {
    var toplam = toplamSlayt(sayac);
    if (toplam < 1) return;
    var simdi = Math.min(Math.max(suankiSlayt(sayac), 1), toplam);
    cizgi.style.setProperty('--k-ilerleme', (simdi / toplam).toFixed(4));
  }

  /* ------------------------------------------------------------------
     ZAMANLAYICIYI DEVRALMA

     Horizon'un kendi otomatik geçişi ayrı bir setInterval ile çalışıyordu
     ve bizim çubuğumuzla aynı saatten beslenmiyordu. Üstelik Horizon,
     fare slaytın üzerindeyken tik atmayı atlıyor (play() içinde ':hover'
     kontrolü var). Sonuç: çubuk dolsa bile slayt değişmiyordu.

     Pebble'da ölçtük: fare slaytın üzerindeyken de geçiş sürüyor ve
     çubuk tam dolduğu anda slayt değişiyor. Aynısını yapmak için
     Horizon'un zamanlayıcısını kapatıp geçişi çubuğa bağlıyoruz:
     çubuğun animasyonu bitince bir sonraki slayta geçiyoruz. Böylece
     çubukla slayt hiçbir zaman birbirinden kaymıyor.
     ------------------------------------------------------------------ */
  function horizonDurdur(kaydirici) {
    try {
      if (typeof kaydirici.suspend === 'function') kaydirici.suspend();
    } catch (e) {
      /* bileşen henüz kurulmadıysa sorun değil */
    }
  }

  function zamanlayiciDevral(kaydirici, cizgi, sure) {
    var dolgu = cizgi.firstElementChild;
    if (!dolgu) return;

    // Süreyi sakla, sonra autoplay özniteliğini kaldır: Horizon'un
    // resume() çağrıları artık kendiliğinden boşa düşüyor.
    kaydirici.dataset.karchirSure = String(sure);
    kaydirici.removeAttribute('autoplay');
    // Tur 142 (erişilebilirlik): otomatik dönerken ekran okuyucu her geçişte
    // slayt metnini yeniden okumasın
    kaydirici.setAttribute('aria-live', 'off');
    horizonDurdur(kaydirici);
    // Bileşen bizden sonra kurulduysa aralığı bir kez daha kapat
    setTimeout(function () {
      horizonDurdur(kaydirici);
    }, 1500);

    function gec() {
      if (typeof kaydirici.next === 'function') kaydirici.next();

      // Emniyet: slayt herhangi bir sebeple değişmediyse (sayaç aynı kaldı,
      // yani çubuğu yeniden başlatan gözcü hiç tetiklenmedi) çubuk dolu
      // kalıp kilitlenmesin — kendimiz yeniden başlatıyoruz.
      setTimeout(function () {
        var bitti =
          typeof dolgu.getAnimations !== 'function' ||
          dolgu.getAnimations().every(function (a) {
            return a.playState === 'finished';
          });
        if (bitti) yenidenBaslat(cizgi);
      }, 700);
    }

    /* Tur 156 (Batuhan, 3 Eki: "başka sekmeye geçip dönünce banner diğerine
       geçerken donuk kalıyor"): Chrome, sekme arkaya atılınca süren yumuşak
       kaydırmayı yarıda bırakabiliyor; programla yapılan kaydırmadan sonra
       yapışma (scroll-snap) da kendiliğinden oturmuyor. Afiş iki slayt
       arasında kalıyor, sayaç ise birini gösteriyordu (bir sonraki geçişe,
       5 sn'ye kadar). Sekme gizlenirken ve geri gelirken afiş, sayacın
       gösterdiği slayta ANINDA oturtulur. Gizliyken çubuk bitse bile geçiş
       başlatılmaz; sekme görünür olunca yapılır. */
    var bekleyenGecis = false;
    function oturt() {
      var sc = (kaydirici.refs && kaydirici.refs.scroller) || kaydirici.querySelector('[ref="scroller"]');
      var slaytlar = kaydirici.slides;
      if (!sc || !slaytlar || !slaytlar.length) return;
      var i = typeof kaydirici.current === 'number' ? kaydirici.current : 0;
      var slayt = slaytlar[i] || slaytlar[0];
      // Horizon'un Scroller.to hesabıyla aynı: offsetLeft - padding-inline-start
      var hedef = slayt.offsetLeft - (parseFloat(getComputedStyle(sc).paddingInlineStart) || 0);
      if (Math.abs(sc.scrollLeft - hedef) > 2) sc.scrollTo({ left: hedef, behavior: 'instant' });
    }

    dolgu.addEventListener('animationend', function (e) {
      if (e.animationName !== 'karchirIlerle') return;
      if (document.hidden) {
        bekleyenGecis = true;
        return;
      }
      gec();
    });

    // Sekme arkaya atılınca sayaç da dursun, öne gelince kaldığı yerden
    document.addEventListener('visibilitychange', function () {
      dolgu.style.animationPlayState = document.hidden || cizgi.dataset.karchirDur ? 'paused' : '';
      oturt();
      if (!document.hidden && bekleyenGecis) {
        bekleyenGecis = false;
        gec();
      }
    });
    // Geri tuşuyla önbellekten dönüşte de (bfcache) yarıda kalmış olabilir
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) oturt();
    });

    // Tur 142 (WCAG 2.2.2): KLAVYE odağı slayttayken geçiş durur, odak
    // çıkınca devam eder. Fare tıklaması (ok düğmesi) durdurmaz; Pebble'daki
    // "fare üstündeyken de geçmeye devam et" davranışı korunur.
    kaydirici.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches(':focus-visible')) return;
      cizgi.dataset.karchirDur = '1';
      dolgu.style.animationPlayState = 'paused';
    });
    kaydirici.addEventListener('focusout', function (e) {
      if (e.relatedTarget && kaydirici.contains(e.relatedTarget)) return;
      if (!cizgi.dataset.karchirDur) return;
      delete cizgi.dataset.karchirDur;
      if (!document.hidden) dolgu.style.animationPlayState = '';
    });
  }

  function kur(sayac) {
    if (sayac.dataset.karchirIlerleme) return;
    sayac.dataset.karchirIlerleme = '1';

    var toplam = toplamSlayt(sayac);
    if (toplam < 2) return; // tek slayt varsa çizgiye gerek yok

    var kaydirici = kaydiriciBul(sayac);

    var cizgi = document.createElement('span');
    cizgi.className = SINIF;
    cizgi.setAttribute('aria-hidden', 'true'); // Tur 142: süs; sayaç bilgiyi veriyor
    cizgi.appendChild(document.createElement('span'));

    // "Hareketi azalt" açıkken zaman çubuğu animasyonu çalışmıyor ve çubuk
    // sürekli DOLU görünüyordu — slayt geçmiyormuş gibi duruyordu (aslında
    // geçiyor). O durumda çubuğu kaçıncı slaytta olduğumuzu gösteren
    // orana çeviriyoruz: animasyon yok ama bilgi doğru.
    var azalt =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sure = azalt ? 0 : slaytSuresi(kaydirici);
    if (sure > 0) {
      // ZAMAN ÇUBUĞU: her slayt başında sıfırdan başlar, slayt süresi
      // boyunca doğrusal dolar. Slayt değişince (otomatik ya da okla)
      // sayaç değişir, biz de animasyonu baştan başlatırız.
      cizgi.classList.add('is-zaman');
      cizgi.style.setProperty('--k-sure', sure + 's');
    }

    sayac.parentNode.insertBefore(cizgi, sayac.nextSibling);

    if (sure > 0) {
      yenidenBaslat(cizgi);
      if (kaydirici) zamanlayiciDevral(kaydirici, cizgi, sure);
    } else if (azalt && kaydirici && kaydirici.hasAttribute('autoplay')) {
      // Tur 142: "Hareketi azalt" açıkken Horizon'un kendi otomatik geçişi de
      // dursun (slideshow.js prefers-reduced-motion'a bakmıyor)
      kaydirici.removeAttribute('autoplay');
      horizonDurdur(kaydirici);
      setTimeout(function () { horizonDurdur(kaydirici); }, 1500);
      oranGuncelle(sayac, cizgi);
    } else {
      oranGuncelle(sayac, cizgi);
    }

    var gozcu = new MutationObserver(function () {
      if (sure > 0) {
        yenidenBaslat(cizgi);
      } else {
        oranGuncelle(sayac, cizgi);
      }
    });
    gozcu.observe(sayac, { childList: true, characterData: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     SLAYT METNİNİN GİRİŞ ANİMASYONU

     Pebble'da slayt yazısı görselin parçası değil, gerçek metin; sayfa
     ilk açıldığında ve her slayt değişiminde aşağıdan yukarı doğru
     yumuşakça beliriyor (ölçüm: 25px kayma + opaklık, satırlar 100ms
     arayla). Bizde de yazı zaten gerçek metin — eksik olan bu giriş
     hareketiydi.

     Animasyonu CSS yapıyor; JavaScript yalnızca "hangi slayt aktif"
     bilgisini veriyor. JavaScript çalışmazsa yazı olduğu gibi görünür.
     ------------------------------------------------------------------ */
  function girisOynat(slayt, gecikme) {
    if (!slayt) return;
    var ic = slayt.querySelector('.slide__content .group-block-content');
    if (!ic) return;

    // Satırlar 100ms arayla giriyor (Pebble ölçümü: 50 / 150 / 250 ...).
    // Sırayı burada dağıtıyoruz çünkü Shopify araya görünmeyen <style>
    // etiketleri koyuyor ve CSS'teki :nth-child sayımı kayıyor.
    var sira = 0;
    for (var i = 0; i < ic.children.length; i++) {
      var c = ic.children[i];
      var ad = c.tagName;
      if (ad === 'STYLE' || ad === 'SCRIPT' || ad === 'TEMPLATE') continue;
      sira++;
      c.style.setProperty('--k-giris-sira', (sira * 100 - 50) + 'ms');
    }

    ic.classList.remove('karchir-giris');
    void ic.offsetWidth; // animasyonu baştan başlatmak için
    ic.style.setProperty('--k-giris-temel', (gecikme || 0) + 'ms');
    ic.classList.add('karchir-giris');
  }

  function aktifSlayt(kaydirici) {
    var acik = kaydirici.querySelector('slideshow-slide[aria-hidden="false"]');
    return acik || kaydirici.querySelector('slideshow-slide');
  }

  function girisKur(kaydirici) {
    if (kaydirici.dataset.karchirGiris) return;
    kaydirici.dataset.karchirGiris = '1';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return; // hareketi azalt açıksa yazı olduğu yerde belirsin
    }

    var sonuncu = aktifSlayt(kaydirici);
    girisOynat(sonuncu, 0);

    kaydirici.addEventListener('slideshow:select', function (e) {
      var slayt = e.detail && e.detail.slide;
      if (!slayt || slayt === sonuncu) return; // aynı slayt için tekrarlama
      sonuncu = slayt;
      girisOynat(slayt, GECIS_GECIKME);
    });
  }

  function tara(kok) {
    var liste = (kok || document).querySelectorAll('.slideshow-controls__counter');
    for (var i = 0; i < liste.length; i++) kur(liste[i]);

    var vitrin = (kok || document).querySelectorAll('.slideshow-section slideshow-component');
    for (var j = 0; j < vitrin.length; j++) girisKur(vitrin[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tara(); });
  } else {
    tara();
  }

  // Tema düzenleyicide bölüm yeniden yüklenince tekrar kur
  document.addEventListener('shopify:section:load', function (e) { tara(e.target); });
})();


/* ==========================================================================
   Ürün karuseli okları (Pebble'daki "Bu hafta öne çıkanlar" düzeni)

   Horizon ürün listesini karusel yaptığında okları listenin ÜZERİNE, sağ
   kenara koyuyor ve bir tıklamada ekranda görünen kart sayısı kadar (4 kart)
   birden atlıyor — 6 ürünlü listede ilk tıklamada sona gidiliyordu.

   Pebble'da (ve bizim kategori bölümümüzde) oklar SAĞ ALTTA, solda ince bir
   ilerleme çizgisiyle birlikte duruyor ve her tıklamada BİR kart kayıyor.
   Aynısını kuruyoruz: Horizon'un kendi oklarını gizleyip kategori
   bölümüyle birebir aynı sınıflara sahip bir kontrol satırı ekliyoruz
   (görünüm, hover dolgusu ve animasyon oradan geliyor — ayrı kod yok).
   ========================================================================== */

(function () {
  'use strict';

  var ISARET = 'karchirUrunOk';

  function kartAdimi(kaydirici) {
    // Kart genişliği + aradaki boşluk. İki kartın sol kenarı arasındaki
    // fark en güvenilir ölçü: boşluk hangi öğede tanımlıysa tanımlı olsun.
    var kartlar = kaydirici.querySelectorAll('product-card, .product-grid__item, li');
    if (kartlar.length > 1) {
      var fark = kartlar[1].getBoundingClientRect().left - kartlar[0].getBoundingClientRect().left;
      if (fark > 20) return fark;
    }
    if (kartlar.length === 1) return kartlar[0].getBoundingClientRect().width;
    return Math.max(200, kaydirici.clientWidth / 4);
  }

  function satirKur(karusel) {
    if (karusel.dataset[ISARET]) return;
    var kaydirici = karusel.querySelector('[ref="scroller"]');
    if (!kaydirici) return;
    karusel.dataset[ISARET] = '1';

    // Horizon'un kendi okları (listenin üzerinde duran yuvarlaklar) kalksın
    var eskiOklar = karusel.querySelectorAll('slideshow-arrows');
    for (var i = 0; i < eskiOklar.length; i++) eskiOklar[i].hidden = true;

    var satir = document.createElement('div');
    satir.className = 'karchir-kat__araclar karchir-urun-araclar';
    satir.innerHTML =
      '<span class="karchir-kat__cubuk" aria-hidden="true">' +
      '<span></span></span>' +
      '<span class="karchir-kat__oklar">' +
      '<button type="button" class="karchir-kat__ok karchir-kat__ok--geri" aria-label="Önceki"></button>' +
      '<button type="button" class="karchir-kat__ok karchir-kat__ok--ileri" aria-label="Sonraki"></button>' +
      '</span>';

    // Ok simgesi: kategori bölümüyle aynı caret SVG'si
    var kaynakOk = document.querySelector('.karchir-kat__ok svg');
    var dugmeler = satir.querySelectorAll('.karchir-kat__ok');
    for (var j = 0; j < dugmeler.length; j++) {
      if (kaynakOk) dugmeler[j].appendChild(kaynakOk.cloneNode(true));
    }

    karusel.parentNode.insertBefore(satir, karusel.nextSibling);

    var cubuk = satir.querySelector('.karchir-kat__cubuk');
    var geri = satir.querySelector('.karchir-kat__ok--geri');
    var ileri = satir.querySelector('.karchir-kat__ok--ileri');

    function guncelle() {
      var tasiyor = kaydirici.scrollWidth > kaydirici.clientWidth + 4;
      satir.hidden = !tasiyor;
      if (!tasiyor) return;

      geri.disabled = kaydirici.scrollLeft <= 2;
      ileri.disabled = kaydirici.scrollLeft + kaydirici.clientWidth >= kaydirici.scrollWidth - 4;

      var adim = kartAdimi(kaydirici);
      var toplam = Math.max(1, Math.round(kaydirici.scrollWidth / adim));
      var gorunen = Math.max(1, Math.floor(kaydirici.clientWidth / adim));
      var ilk = Math.round(kaydirici.scrollLeft / adim);
      var oran = Math.min(Math.max((ilk + gorunen) / toplam, 0.05), 1);
      cubuk.style.setProperty('--k-kat-oran', oran.toFixed(3));
    }

    function adimla(yon) {
      kaydirici.scrollBy({ left: kartAdimi(kaydirici) * yon, behavior: 'smooth' });
      window.setTimeout(guncelle, 420);
    }

    geri.addEventListener('click', function () { adimla(-1); });
    ileri.addEventListener('click', function () { adimla(1); });
    kaydirici.addEventListener('scroll', guncelle, { passive: true });

    var zaman;
    window.addEventListener('resize', function () {
      window.clearTimeout(zaman);
      zaman = window.setTimeout(guncelle, 150);
    });

    // Sekme değişince (diğer sekmenin listesi gizliyken ölçüleri 0 oluyor)
    // panel görünür olur olmaz satırı yeniden hesapla.
    var kabuk = karusel.closest ? karusel.closest('.shopify-section') : null;
    if (kabuk && window.MutationObserver) {
      new MutationObserver(function () {
        window.setTimeout(guncelle, 60);
      }).observe(kabuk, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    }

    guncelle();
    // Kartlar tembel yüklendiği için ölçüler biraz sonra oturuyor
    window.setTimeout(guncelle, 600);
  }

  function tara(kok) {
    var liste = (kok || document).querySelectorAll('slideshow-component.resource-list__carousel');
    for (var i = 0; i < liste.length; i++) satirKur(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tara(); });
  } else {
    tara();
  }
  document.addEventListener('shopify:section:load', function (e) { tara(e.target); });
})();

/* ==========================================================================
   2) Ürün sekmeleri (Pebble 5)

   sections/karchir-urun-sekmeleri.liquid başlığı ve sekme haplarını çiziyor.
   Ürün kartlarını yeniden yazmıyoruz: hemen ardından gelen Horizon "Ürün
   listesi" bölümlerini açıp kapatıyoruz, böylece rozet / hızlı ekle / renk
   örneği gibi her şey Horizon'un kendi kodundan gelmeye devam ediyor.

   JavaScript çalışmazsa bütün listeler görünür kalır — içerik kaybolmaz.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof customElements === 'undefined') return;

  function bolumKabugu(el) {
    // Horizon her bölümü .shopify-section sarmalayıcısına koyuyor
    var n = el;
    while (n && n.parentElement) {
      if (n.classList && n.classList.contains('shopify-section')) return n;
      n = n.parentElement;
    }
    return el;
  }

  class KarchirSekmeler extends HTMLElement {
    connectedCallback() {
      this.haplar = Array.prototype.slice.call(
        this.querySelectorAll('.karchir-sekmeler__hap')
      );
      if (this.haplar.length < 2) return;

      var adet = parseInt(this.getAttribute('data-yonetilen'), 10) || this.haplar.length;
      this.paneller = [];

      var kabuk = bolumKabugu(this);
      var sonraki = kabuk.nextElementSibling;
      while (sonraki && this.paneller.length < adet) {
        if (sonraki.classList && sonraki.classList.contains('shopify-section')) {
          sonraki.classList.add('karchir-sekme-panel');
          this.paneller.push(sonraki);
        }
        sonraki = sonraki.nextElementSibling;
      }

      if (this.paneller.length < 2) return; // yönetecek bölüm yoksa dokunma

      var self = this;
      this.haplar.forEach(function (hap) {
        hap.addEventListener('click', function () {
          self.sec(parseInt(hap.getAttribute('data-sira'), 10) || 0);
        });
        // Tur 122: kart görselleri artık lazy; gizli sekmenin görselleri
        // parmak/fare hapa değdiği anda indirilmeye başlasın ki sekme
        // açıldığında boş kutu görünmesin.
        var isit = function () {
          var p = self.paneller[parseInt(hap.getAttribute('data-sira'), 10) || 0];
          if (!p || p.dataset.karchirIsindi) return;
          p.dataset.karchirIsindi = '1';
          p.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            img.loading = 'eager';
          });
        };
        hap.addEventListener('pointerenter', isit);
        hap.addEventListener('touchstart', isit, { passive: true });
        hap.addEventListener('focus', isit);
      });

      this.sec(0);
    }

    sec(sira) {
      this.haplar.forEach(function (hap, i) {
        hap.setAttribute('aria-pressed', i === sira ? 'true' : 'false');
      });
      this.paneller.forEach(function (panel, i) {
        if (i === sira) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('karchir-sekmeler')) {
    customElements.define('karchir-sekmeler', KarchirSekmeler);
  }
})();

/* ==========================================================================
   3) Akan kartlar — değişen başlık (Pebble 3)

   Bölüm ekrandayken kaydırma ilerlemesine göre ortadaki başlığı değiştirir.
   Bölüm ekrandan çıkınca döngü durur (IntersectionObserver), böylece boşuna
   iş yapılmaz. JavaScript çalışmazsa ilk başlık görünür kalır.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof customElements === 'undefined') return;

  function kaydiriciBul() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 4) return w;
    return document.scrollingElement || document.documentElement;
  }

  class KarchirAkan extends HTMLElement {
    connectedCallback() {
      this.basliklar = Array.prototype.slice.call(
        this.querySelectorAll('.karchir-akan__baslik')
      );
      if (this.basliklar.length < 2) return;

      this.aktif = 0;
      this.beklemede = false;
      this.guncelle = this.guncelle.bind(this);
      this.planla = this.planla.bind(this);
      // Tur 142 (akıcılık): değişkeni yalnız şerit okuyor; kökte yazılınca
      // bölümün tüm alt ağacı her karede yeniden hesaplanıyordu
      this.serit = this.querySelector('.karchir-akan__serit') || this;
      this.sonKay = '';

      this.gozcu = new IntersectionObserver(
        function (kayitlar) {
          for (var i = 0; i < kayitlar.length; i++) {
            if (kayitlar[i].isIntersecting) this.baglan();
            else this.cikar();
          }
        }.bind(this),
        { rootMargin: '0px' }
      );
      this.gozcu.observe(this);
    }

    disconnectedCallback() {
      this.cikar();
      if (this.gozcu) this.gozcu.disconnect();
    }

    baglan() {
      if (this.bagli) return;
      this.bagli = true;
      this.kaydirici = kaydiriciBul();
      this.kaydirici.addEventListener('scroll', this.planla, { passive: true });
      window.addEventListener('scroll', this.planla, { passive: true });
      this.guncelle();
    }

    cikar() {
      if (!this.bagli) return;
      this.bagli = false;
      if (this.kaydirici) this.kaydirici.removeEventListener('scroll', this.planla);
      window.removeEventListener('scroll', this.planla);
    }

    planla() {
      if (this.beklemede) return;
      this.beklemede = true;
      window.requestAnimationFrame(this.guncelle);
    }

    guncelle() {
      this.beklemede = false;
      var k = this.getBoundingClientRect();
      var ekran = window.innerHeight || 800;

      // İlerleme: bölüm ekranı geçerken 0 -> 1.
      // Yalnızca ORTA bölge sayılıyor; başta ve sonda başlık şeridi
      // uçlarda takılı kalsın, boşluğa kaymasın.
      var toplam = k.height + ekran;
      var ham = toplam > 0 ? (ekran - k.top) / toplam : 0;
      var bas = 0.18;
      var son = 0.82;
      var ilerleme = (ham - bas) / (son - bas);
      ilerleme = Math.min(Math.max(ilerleme, 0), 1);

      // Şerit sürekli kayıyor: 0 -> (başlık sayısı - 1) satır.
      // Tam sayıya yuvarlamıyoruz; Pebble'daki gibi akıcı.
      var kay = ilerleme * (this.basliklar.length - 1);
      var kayYazi = kay.toFixed(4);
      if (kayYazi !== this.sonKay) {
        this.sonKay = kayYazi;
        this.serit.style.setProperty('--k-akan-kay', kayYazi);
      }

      // Ortadaki (en görünür) başlığı erişilebilirlik için işaretle
      var sira = Math.round(kay);
      if (sira !== this.aktif) {
        this.aktif = sira;
        for (var i = 0; i < this.basliklar.length; i++) {
          this.basliklar[i].setAttribute('aria-current', i === sira ? 'true' : 'false');
        }
      }
    }
  }

  if (!customElements.get('karchir-akan')) {
    customElements.define('karchir-akan', KarchirAkan);
  }
})();

/* ==========================================================================
   4) Kategoriler (Pebble 2)

   - Erkek / Kız hapları listeyi değiştirir
   - Tekerlek / trackpad: hareket ne kadar hızlı olursa olsun TEK kart ilerler
   - Oklar: tek kart ileri/geri, yumuşak kayma
   - İlerleme çubuğu: görünen son kartın sırası / toplam kart
   ========================================================================== */

(function () {
  'use strict';

  if (typeof customElements === 'undefined') return;

  class KarchirKategoriler extends HTMLElement {
    connectedCallback() {
      this.haplar = Array.prototype.slice.call(this.querySelectorAll('.karchir-kat__hap'));
      this.kaydiricilar = Array.prototype.slice.call(this.querySelectorAll('.karchir-kat__kaydirici'));
      this.cubuk = this.querySelector('.karchir-kat__cubuk');
      this.dolgu = this.cubuk && this.cubuk.firstElementChild;
      this.geri = this.querySelector('.karchir-kat__ok--geri');
      this.ileri = this.querySelector('.karchir-kat__ok--ileri');
      if (!this.kaydiricilar.length) return;

      this.kilit = false; // tekerlek kilidi: bir jestte tek kart
      this.aktifGrup = this.getAttribute('data-ilk-sekme') || 'erkek';

      var self = this;

      this.haplar.forEach(function (hap) {
        hap.addEventListener('click', function () {
          self.grupSec(hap.getAttribute('data-grup'));
        });
      });

      if (this.geri) this.geri.addEventListener('click', function () { self.adimla(-1); });
      if (this.ileri) this.ileri.addEventListener('click', function () { self.adimla(1); });

      this.kaydiricilar.forEach(function (k) {
        // Kaydırma dinleyicisi HEM çubuğu HEM okların pasiflik durumunu
        // güncellemeli. Yalnız çubuk güncellenince, parmakla/tekerlekle
        // kaydırdıktan sonra oklar bayat kalıyordu (listenin başındayken
        // sol ok hâlâ aktif görünüyordu).
        k.addEventListener('scroll', function () {
          self.cubukGuncelle();
          self.oklarGuncelle();
        }, { passive: true });
        k.addEventListener('wheel', function (e) { self.tekerlek(e, k); }, { passive: false });
      });

      // Pencere yeniden boyutlanınca kaç kart sığdığı değişiyor: araç
      // satırının görünürlüğü ve okların pasiflik durumu bayat kalmasın.
      this.planla = function () {
        window.clearTimeout(self.zaman);
        self.zaman = window.setTimeout(function () {
          self.cubukGuncelle();
          self.oklarGuncelle();
        }, 150);
      };
      window.addEventListener('resize', this.planla);

      this.cubukGuncelle();
      this.oklarGuncelle();
    }

    disconnectedCallback() {
      if (this.planla) window.removeEventListener('resize', this.planla);
    }

    aktif() {
      for (var i = 0; i < this.kaydiricilar.length; i++) {
        if (!this.kaydiricilar[i].hasAttribute('hidden')) return this.kaydiricilar[i];
      }
      return this.kaydiricilar[0];
    }

    kartGenisligi(k) {
      var kart = k.querySelector('.karchir-kat__kart');
      if (!kart) return 1;
      var stil = window.getComputedStyle(k);
      var bosluk = parseFloat(stil.columnGap || stil.gap) || 0;
      return kart.getBoundingClientRect().width + bosluk;
    }

    grupSec(grup) {
      if (grup === this.aktifGrup) return;
      this.aktifGrup = grup;
      this.haplar.forEach(function (hap) {
        hap.setAttribute('aria-pressed', hap.getAttribute('data-grup') === grup ? 'true' : 'false');
      });
      this.kaydiricilar.forEach(function (k) {
        if (k.getAttribute('data-grup') === grup) {
          k.removeAttribute('hidden');
          k.scrollLeft = 0;
        } else {
          k.setAttribute('hidden', '');
        }
      });
      this.cubukGuncelle();
      this.oklarGuncelle();
    }

    adimla(yon) {
      var k = this.aktif();
      k.scrollBy({ left: this.kartGenisligi(k) * yon, behavior: 'smooth' });
      // Yumuşak kayma bitmeden çubuğu güncellemek için kısa bir bekleme
      var self = this;
      window.setTimeout(function () { self.cubukGuncelle(); self.oklarGuncelle(); }, 420);
    }

    // Tekerlek: YALNIZCA yatay hareketi karşılıyoruz.
    // Dikey hareketi hiç ellemiyoruz ki trackpad'de iki parmakla aşağı
    // kaydırırken liste araya girmesin, sayfa normal aksın.
    // Yatay hareketin büyüklüğü ne olursa olsun tek kart ilerliyor.
    tekerlek(e, k) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // dikey: sayfaya bırak
      e.preventDefault();
      if (this.kilit) return;
      this.kilit = true;
      this.adimla(e.deltaX > 0 ? 1 : -1);
      var self = this;
      window.setTimeout(function () { self.kilit = false; }, 450);
    }

    cubukGuncelle() {
      if (!this.dolgu) return;
      var k = this.aktif();
      var kart = this.kartGenisligi(k);
      var toplam = k.querySelectorAll('.karchir-kat__kart').length;
      if (!toplam || kart <= 1) return;

      // Görünen son kartın sırası / toplam kart.
      // floor: yarım görünen kartı saymıyoruz, yoksa çubuk daha baştan
      // neredeyse dolu başlıyor.
      var gorunen = Math.max(1, Math.floor(k.clientWidth / kart));
      var ilk = Math.round(k.scrollLeft / kart);
      var son = Math.min(ilk + gorunen, toplam);
      var oran = Math.min(Math.max(son / toplam, 0.05), 1);

      this.cubuk.style.setProperty('--k-kat-oran', oran.toFixed(3));
    }

    oklarGuncelle() {
      var k = this.aktif();
      var sonda = k.scrollLeft + k.clientWidth >= k.scrollWidth - 4;
      if (this.geri) this.geri.disabled = k.scrollLeft <= 2;
      if (this.ileri) this.ileri.disabled = sonda;

      var tasiyor = k.scrollWidth > k.clientWidth + 4;

      // Araç satırı (oklar + çubuk) yalnızca kaydırılacak yer varken
      // görünüyor. Tur 15'te kart genişliği Pebble ölçüsüne çekilince
      // masaüstünde beş kategori satıra tam sığar oldu; satır taşmayınca
      // iki ok da kalıcı olarak pasif kalıyordu — iki ölü düğme duruyordu.
      // Koleksiyon eklenip satır taşarsa araçlar kendiliğinden geri gelir.
      var araclar = this.querySelector('.karchir-kat__araclar');
      if (araclar) araclar.hidden = !tasiyor;

      // Kaydırılacak yer yoksa çubuk da soluk dursun
      if (this.cubuk) {
        this.cubuk.classList.toggle('is-pasif', !tasiyor);
      }
    }
  }

  if (!customElements.get('karchir-kategoriler')) {
    customElements.define('karchir-kategoriler', KarchirKategoriler);
  }
})();

/* ==========================================================================
   5) Kimin için (Pebble 4)

   Bölüm ekranda sabitken kaydırma ilerlemesine göre aktif kelime değişiyor;
   soldaki büyük görsel, başlık ve alttaki açıklama da onunla değişiyor.
   Döngü yalnız bölüm ekrandayken çalışır.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof customElements === 'undefined') return;

  class KarchirOutfit extends HTMLElement {
    connectedCallback() {
      this.satirlar = Array.prototype.slice.call(this.querySelectorAll('.karchir-outfit__satir'));
      this.paneller = Array.prototype.slice.call(this.querySelectorAll('.karchir-outfit__panel'));
      this.aciklamalar = Array.prototype.slice.call(this.querySelectorAll('.karchir-outfit__aciklama'));
      if (this.satirlar.length < 2) return;

      this.aktif = 0;

      // Bölüm artık sayfa kaydırma davranışına hiç karışmıyor.
      // Aktif kelime yalnızca fareyle üstüne gelince değişiyor;
      // fare çekilince en son seçilen kelimede kalıyor.
      var self = this;
      this.satirlar.forEach(function (satir, i) {
        satir.addEventListener('pointerenter', function (e) {
          // Dokunmatikte pointerenter de tetikleniyor; orada seçimi
          // tıklama olayına bırakıyoruz ki yanlışlıkla değişmesin.
          if (e.pointerType === 'touch') return;
          self.sec(i);
        });

        // Mobil: ilk dokunuş kelimeyi seçiyor, seçili kelimeye tekrar
        // dokununca koleksiyona gidiyor. Masaüstünde kelime zaten
        // hover ile seçili olduğu için tıklama doğrudan geçiyor.
        satir.addEventListener('click', function (e) {
          if (self.aktif === i) return;
          e.preventDefault();
          self.sec(i);
        });
      });
    }

    sec(sira) {
      sira = Math.min(Math.max(sira, 0), this.satirlar.length - 1);
      if (sira === this.aktif) return;
      this.aktif = sira;
      var isaretle = function (liste) {
        liste.forEach(function (el, i) { el.classList.toggle('is-aktif', i === sira); });
      };
      isaretle(this.satirlar);
      isaretle(this.paneller);
      isaretle(this.aciklamalar);
    }
  }

  if (!customElements.get('karchir-outfit')) {
    customElements.define('karchir-outfit', KarchirOutfit);
  }
})();

/* --------------------------------------------------------------------------
   6 — HIZLI BAKIŞ (büyüteç)

   Ürün görselinin sağ üstündeki büyüteç, kendi penceresini açmıyor.
   Aynı kartın içindeki Horizon "quick-add" bileşeninin handleClick'ini
   çağırıyor; Horizon ürünü çekip kendi hızlı bakış penceresinde açıyor.
   Tek varyantlı üründe de çalışıyor, çünkü quick-add-component her
   durumda kartta duruyor.

   Kart bir bağlantının içinde olduğu için tıklamayı durduruyoruz,
   yoksa tarayıcı ürün sayfasına gidiyor.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (olay) {
      var dugme = olay.target instanceof Element ? olay.target.closest('[data-karchir-bakis]') : null;
      if (!dugme) return;

      olay.preventDefault();
      olay.stopPropagation();

      var kap = dugme.closest('product-card') || dugme.closest('.card-gallery') || document;
      var hizli = kap.querySelector('quick-add-component');

      if (hizli && typeof hizli.handleClick === 'function') {
        hizli.handleClick(olay);
        return;
      }

      // Bileşen henüz yüklenmediyse ürün sayfasına düş.
      var bag = kap.querySelector('a[href]');
      if (bag) window.location.href = bag.getAttribute('href');
    },
    true
  );
})();

/* --------------------------------------------------------------------------
   7 — VİDEOLU VİTRİN

   Oklarla slayt değişiyor: hem sağdaki büyük medya hem soldaki ürün
   kartı aynı anda değişiyor. Sayaç ve dolan çizgi güncelleniyor.
   Yalnız aktif slaydın videosu oynuyor; "hareketi azalt" açıkken
   hiçbiri oynatılmıyor.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var AZALT = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  class KarchirVideo extends HTMLElement {
    connectedCallback() {
      this.medyalar = Array.prototype.slice.call(this.querySelectorAll('.karchir-video__medya'));
      this.urunler = Array.prototype.slice.call(this.querySelectorAll('.karchir-video__urun'));
      this.sayac = this.querySelector('.karchir-video__sayac-simdi');
      this.dolgu = this.querySelector('.karchir-video__cubuk > span');
      this.cubuk = this.querySelector('.karchir-video__cubuk');
      this.geri = this.querySelector('.karchir-video__ok.karchir-kat__ok--geri');
      this.ileri = this.querySelector('.karchir-video__ok.karchir-kat__ok--ileri');
      this.adet = this.medyalar.length;
      if (this.adet === 0) return;

      /* Tur 88 (Batuhan): tek medya varsa ilerleme çubuğu, sayaç ve oklar
         anlamsız — araç satırı gizli. */
      var araclar = this.querySelector('.karchir-video__araclar');
      if (araclar) araclar.hidden = this.adet < 2;

      this.aktif = 0;
      var self = this;
      if (this.geri) this.geri.addEventListener('click', function () { self.git(self.aktif - 1); });
      if (this.ileri) this.ileri.addEventListener('click', function () { self.git(self.aktif + 1); });

      this.guncelle();
    }

    git(sira) {
      if (this.adet < 1) return;
      // Başa/sona gelince döner
      if (sira < 0) sira = this.adet - 1;
      if (sira > this.adet - 1) sira = 0;
      if (sira === this.aktif) return;
      this.aktif = sira;
      this.guncelle();
    }

    guncelle() {
      var sira = this.aktif;

      this.medyalar.forEach(function (el, i) {
        el.classList.toggle('is-aktif', i === sira);
        var v = el.querySelector('video');
        if (!v) return;
        if (i === sira && !(AZALT && AZALT.matches)) {
          var s = v.play();
          if (s && s.catch) s.catch(function () {});
        } else {
          v.pause();
        }
      });

      this.urunler.forEach(function (el, i) {
        var acik = i === sira;
        el.classList.toggle('is-aktif', acik);
        if (acik) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });

      if (this.sayac) this.sayac.textContent = String(sira + 1);

      var oran = this.adet > 0 ? (sira + 1) / this.adet : 0;
      if (this.dolgu) this.dolgu.style.width = (oran * 100).toFixed(2) + '%';
    }
  }

  if (!customElements.get('karchir-video')) {
    customElements.define('karchir-video', KarchirVideo);
  }
})();

/* --------------------------------------------------------------------------
   8 — YORUMLAR: farklı hızlarda akan kartlar

   Bölüm ekrandayken, sayfa ilerlemesine göre her kart kendi hızıyla
   dikey kayıyor (parallax). Kartlar başlığın üstünden geçiyor.
   Bölüm ekrandan çıkınca hesaplama duruyor; "hareketi azalt" açıkken
   hiç kaydırma yapılmıyor.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var AZALT = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var GENIS = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  class KarchirYorumlar extends HTMLElement {
    connectedCallback() {
      this.kartlar = Array.prototype.slice.call(this.querySelectorAll('.karchir-yorum'));
      if (!this.kartlar.length) return;
      // Tur 142 (akıcılık): hız Liquid'in satır içi stilinde sabit; her karede
      // getComputedStyle ile okumak kart başına zorunlu stil hesabı yaptırıyordu
      this.hizlar = this.kartlar.map(function (k) {
        return parseFloat(k.style.getPropertyValue('--k-yorum-hiz')) || 1;
      });
      this.son = [];

      this.beklemede = false;
      this.guncelle = this.guncelle.bind(this);
      this.planla = this.planla.bind(this);

      var self = this;
      this.gozcu = new IntersectionObserver(
        function (kayitlar) {
          for (var i = 0; i < kayitlar.length; i++) {
            if (kayitlar[i].isIntersecting) self.baglan();
            else self.cikar();
          }
        },
        { rootMargin: '120px' }
      );
      this.gozcu.observe(this);
    }

    disconnectedCallback() {
      this.cikar();
      if (this.gozcu) this.gozcu.disconnect();
    }

    kaydiriciBul() {
      var w = document.querySelector('.page-wrapper');
      if (w && w.scrollHeight > w.clientHeight + 4) return w;
      return document.scrollingElement || document.documentElement;
    }

    baglan() {
      if (this.bagli) return;
      this.bagli = true;
      this.kaydirici = this.kaydiriciBul();
      this.kaydirici.addEventListener('scroll', this.planla, { passive: true });
      window.addEventListener('scroll', this.planla, { passive: true });
      window.addEventListener('resize', this.planla);
      this.guncelle();
    }

    cikar() {
      if (!this.bagli) return;
      this.bagli = false;
      if (this.kaydirici) this.kaydirici.removeEventListener('scroll', this.planla);
      window.removeEventListener('scroll', this.planla);
      window.removeEventListener('resize', this.planla);
    }

    planla() {
      if (this.beklemede) return;
      this.beklemede = true;
      window.requestAnimationFrame(this.guncelle);
    }

    guncelle() {
      this.beklemede = false;

      var kapali = (AZALT && AZALT.matches) || !(GENIS && GENIS.matches);
      if (kapali) {
        if (this.son.length) {
          this.kartlar.forEach(function (k) { k.style.removeProperty('--k-yorum-akis'); });
          this.son = [];
        }
        return;
      }

      var k = this.getBoundingClientRect();
      var ekran = window.innerHeight || 800;
      // Bölümün altı ekranın üstüne değdiğinde 0, üstü ekranın altına
      // değdiğinde 1 olan ilerleme
      var yol = k.height + ekran;
      var ilerleme = Math.min(Math.max((ekran - k.top) / yol, 0), 1);

      // Orta noktada 0, uçlarda +/- kayma (yalnız yazma; değişmediyse yazma)
      for (var i = 0; i < this.kartlar.length; i++) {
        var kayma = ((0.5 - ilerleme) * this.hizlar[i] * 220).toFixed(1);
        if (kayma === this.son[i]) continue;
        this.son[i] = kayma;
        this.kartlar[i].style.setProperty('--k-yorum-akis', kayma + 'px');
      }
    }
  }

  if (!customElements.get('karchir-yorumlar')) {
    customElements.define('karchir-yorumlar', KarchirYorumlar);
  }
})();

/* --------------------------------------------------------------------------
   9 — HEADER YAPIŞMA DURUMU DÜZELTİCİSİ

   Bulunan hata (tarayıcıda ölçüldü, 1280px): pencere yeniden
   boyutlandıktan sonra sayfa en üste dönse bile header'ın
   data-sticky-state değeri "active" olarak kilitli kalıyordu. Bu
   durumda kart hali geri gelmiyor, header tam genişlikte kalıyor ve
   duyuru şeridi ile header arasında beyaz bir boşluk görünüyordu.

   Sebep: Horizon'un yapışma gözlemcisi (IntersectionObserver) yalnız
   990px eşiği geçilince yeniden kuruluyor (assets/header.js —
   handleBreakpointChange). Aynı kırılım içinde yapılan boyut
   değişikliklerinde gözlemci yeniden tetiklenmeyebiliyor.

   Çözüm: yalnızca KESİN olan iki durumu düzeltiyoruz, arasını
   Horizon'a bırakıyoruz:
     • header'ın üst kenarı ekranın üstündeyse  -> active
     • sayfa en üstteyse ve header aşağıdaysa   -> inactive
   "idle" durumuna hiç dokunmuyoruz (yukarı kaydırınca beliren kip).
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var header = null;
  var beklemede = false;

  /* Tur 142: kaydırma miktarı iki kaydırıcıdan okunur (990px ve üstünde
     .page-wrapper, altında belge). Kurulumda "hangisi kaydırıyor" diye
     scrollHeight okumak, sayfa daha çizilmeden tüm düzeni hesaplatıyordu
     (mobil koleksiyonda 122 ms). */
  function kaydirmaMiktari() {
    var w = document.querySelector('.page-wrapper');
    var d = document.scrollingElement || document.documentElement;
    return Math.max(w ? w.scrollTop : 0, d.scrollTop);
  }

  /* Header'ın "transparent" niteliğini body'ye sınıf olarak yansıtıyoruz.
     Sebep: hero'yu yukarı çeken kural önce yalnız :has() ile yazılıydı ve
     kaydırdıktan sonra tarayıcı eşleşmeyi geri getirmiyordu (ölçüldü:
     margin-top -30px -> 0px). Sınıfa bağlı kural bu sorunu yaşamıyor. */
  function seffafSinifi() {
    if (!header) return;
    document.body.classList.toggle('k-seffaf-header', header.hasAttribute('transparent'));
  }

  function duzelt() {
    beklemede = false;
    if (!header) return;

    seffafSinifi();

    var durum = header.dataset.stickyState;
    if (durum !== 'active' && durum !== 'inactive') return; // idle'a dokunma

    var ust = header.getBoundingClientRect().top;
    var kaydirma = kaydirmaMiktari();

    if (ust <= 0.5 && durum !== 'active') {
      header.dataset.stickyState = 'active';
    } else if (ust > 0.5 && kaydirma <= 1 && durum !== 'inactive') {
      header.dataset.stickyState = 'inactive';
    }
  }

  function planla() {
    if (beklemede) return;
    beklemede = true;
    window.requestAnimationFrame(duzelt);
  }

  function kur() {
    header = document.querySelector('#header-component');
    if (!header || !header.hasAttribute('sticky')) return;

    var w = document.querySelector('.page-wrapper');
    if (w) w.addEventListener('scroll', planla, { passive: true });
    window.addEventListener('scroll', planla, { passive: true });
    window.addEventListener('resize', planla);
    window.addEventListener('orientationchange', planla);
    if (window.ResizeObserver) {
      var go = new ResizeObserver(planla);
      go.observe(document.documentElement);
    }

    // Horizon'un (boyutlandirmadan sonra bayatlamis) gozlemcisi bizim
    // duzeltmemizden SONRA da yanlis deger yazabiliyor. Bu yuzden
    // data-sticky-state degisimini de dinleyip aninda duzeltiyoruz.
    // Dogru degeri yazdigimizda tekrar tetiklenip duruyor, dongu olmuyor.
    if (window.MutationObserver) {
      var mo = new MutationObserver(planla);
      mo.observe(header, { attributes: true, attributeFilter: ['data-sticky-state', 'transparent'] });
    }

    seffafSinifi();
    // İlk ölçüm sayfa yüklendikten sonra: açılışta zorunlu düzen olmasın
    if (document.readyState === 'complete') planla();
    else window.addEventListener('load', planla, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur);
  else kur();
})();


/* Tur 122 (hız): data-src'li videolar ekrana 600px kala yüklenip oynatılır.
   Sayfa açılışında 1,7 MB video inmesin (önce 4,4 MB ve açılışta iniyordu).
   Tur 142 (akıcılık): video ekran dışındayken oynamaz (önceden bir kez başlayınca
   sayfanın dibinde de çözülmeye devam ediyordu); geri gelince — biz durdurduysak —
   kaldığı yerden devam eder. Kapak (poster) da ekrana yaklaşınca verilir. */
(function () {
  'use strict';
  function oynat(v) {
    var o = v.play && v.play();
    if (o && o.catch) o.catch(function () {});
  }
  function yukle(v) {
    if (v.dataset.poster && !v.getAttribute('poster')) v.poster = v.dataset.poster;
    if (!v.dataset.src || v.getAttribute('src')) return;
    v.src = v.dataset.src;
    v.preload = 'auto';
    oynat(v);
  }
  function kur() {
    var vler = document.querySelectorAll('video[data-src]');
    if (!vler.length) return;
    if (!('IntersectionObserver' in window)) { vler.forEach(yukle); return; }
    // 990px ve üstünde sayfayı .page-wrapper kaydırıyor; kök o olmazsa rootMargin yok sayılır
    var kok = window.matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
    var yukleyici = new IntersectionObserver(function (kayitlar) {
      kayitlar.forEach(function (k) { if (k.isIntersecting) { yukle(k.target); yukleyici.unobserve(k.target); } });
    }, { root: kok, rootMargin: '600px 0px' });
    var durdurucu = new IntersectionObserver(function (kayitlar) {
      kayitlar.forEach(function (k) {
        var v = k.target;
        v.dataset.kGorunur = k.isIntersecting ? '1' : '0';
        if (k.isIntersecting) {
          if (v.dataset.kEkranDisi) { delete v.dataset.kEkranDisi; oynat(v); }
        } else if (!v.paused) {
          v.dataset.kEkranDisi = '1';
          v.pause();
        }
      });
    }, { root: kok, rootMargin: '100px 0px' });
    vler.forEach(function (v) {
      // autoplay ya da KarchirVideo'nun erken play() çağrısı ekran dışındayken başlatırsa geri al
      v.addEventListener('play', function () {
        if (v.dataset.kGorunur === '0') { v.dataset.kEkranDisi = '1'; v.pause(); }
      });
      yukleyici.observe(v);
      durdurucu.observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
})();


/* Tur 142 (erişilebilirlik + yapay zekâ ajanları) — dört küçük düzeltme:
   1) Gizli slayttaki bağlantı/düğmeler Tab sırasından çıkar (aria-hidden-focus).
      Horizon görünmeyen slayta yalnız aria-hidden yazıyor. inert KULLANMIYORUZ:
      %70'ten az görünen yarım kart da aria-hidden oluyor; inert ona dokunmayı
      da kapatırdı. tabindex=-1 fare/dokunma tıklamasını bozmaz.
   2) Duyuru çubuğu: ekran okuyucuya her geçişte yeniden okunmasın; klavye
      odağı içindeyken dursun; "Hareketi azalt" açıksa hiç dönmesin.
   3) Mobil menü Escape ile kapanınca odak "Menü" düğmesine dönsün.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var SECICI = 'a[href], button, input, select, textarea, iframe, summary, [tabindex]';
  /* Ürün karuselinde (resource-list__carousel) %70'ten az görünen kart da
     aria-hidden oluyor; oraya tabindex=-1 verince mobilde klavyeyle yalnız ilk
     karta ulaşılıyordu (okla ilerletme yok). Karuselin kendi slaytlarında
     aria-hidden'ı kaldırıyoruz: kartlar hem klavyeye hem ekran okuyucuya açık. */
  function karuselSlaytiMi(slayt) {
    var ss = slayt.parentElement && slayt.parentElement.closest('slideshow-component');
    return !!(ss && ss.classList.contains('resource-list__carousel'));
  }
  var sonHeroDegisim = 0;
  function odakAyarla(kok) {
    if (kok.tagName === 'SLIDESHOW-SLIDE') {
      if (kok.getAttribute('aria-hidden') === 'true' && karuselSlaytiMi(kok)) kok.removeAttribute('aria-hidden');
      if (kok.closest('.slideshow-section')) {
        sonHeroDegisim = performance.now();
        // Klavye odağı gizlenen hero slaytında kaldıysa görünen slayta taşı
        var ak = document.activeElement;
        if (kok.getAttribute('aria-hidden') === 'true' && ak && kok.contains(ak) && ak.matches(':focus-visible')) {
          var gorunen = kok.parentElement && kok.parentElement.querySelector('slideshow-slide[aria-hidden="false"]');
          var hedef = gorunen && gorunen.querySelector('a[href], button');
          if (hedef) requestAnimationFrame(function () { hedef.focus({ preventScroll: true }); });
        }
      }
    }
    var ogeler = kok.querySelectorAll(SECICI);
    for (var i = 0; i < ogeler.length; i++) {
      var el = ogeler[i];
      var gizli = !!el.closest('slideshow-slide[aria-hidden="true"]');
      if (gizli && !el.hasAttribute('data-k-tabindex')) {
        var t = el.getAttribute('tabindex');
        el.setAttribute('data-k-tabindex', t === null ? '' : t);
        el.setAttribute('tabindex', '-1');
      } else if (!gizli && el.hasAttribute('data-k-tabindex')) {
        var eski = el.getAttribute('data-k-tabindex');
        if (eski === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', eski);
        el.removeAttribute('data-k-tabindex');
      }
    }
  }
  new MutationObserver(function (kayitlar) {
    for (var i = 0; i < kayitlar.length; i++) {
      var h = kayitlar[i].target;
      if (h.nodeType === 1 && h.tagName === 'SLIDESHOW-SLIDE') odakAyarla(h);
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

  function duyuruKur() {
    var azalt = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('announcement-bar-component[autoplay]').forEach(function (s) {
      if (s.dataset.karchirErisim) return;
      s.dataset.karchirErisim = '1';
      s.setAttribute('aria-live', 'off');
      s.addEventListener('focusin', function () {
        if (typeof s.suspend === 'function') s.suspend();
      });
      s.addEventListener('focusout', function (e) {
        if (e.relatedTarget && s.contains(e.relatedTarget)) return;
        if (typeof s.resume === 'function') s.resume();
      });
      if (azalt && typeof s.pause === 'function') s.pause();
    });
  }

  function kur() {
    document.querySelectorAll('slideshow-slide').forEach(odakAyarla);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('announcement-bar-component').then(duyuruKur);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur);
  else kur();

  /* Hero döngü geçişinde Horizon hedef slaytı DOM'da taşıyor (replaceWith);
     tam o anda klavye odağı o slayttaysa odak body'ye düşüyordu. Geçişten
     hemen sonra ve klavyeyle gelinmiş odak için geri veriyoruz. */
  var sonKlavyeOdagi = null;
  var sonIsaretci = 0;
  document.addEventListener('pointerdown', function () { sonIsaretci = performance.now(); }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    sonKlavyeOdagi = t && t.matches && t.matches(':focus-visible') ? t : null;
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (e.relatedTarget || t !== sonKlavyeOdagi || !t.closest || !t.closest('.slideshow-section')) return;
    requestAnimationFrame(function () {
      if (performance.now() - sonHeroDegisim > 600) return;
      if (performance.now() - sonIsaretci < 600) return; // kullanıcı fareyle başka yere bastı
      if ((document.activeElement === document.body || !document.activeElement) && t.isConnected) {
        t.focus({ preventScroll: true });
      }
    });
  });

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var d = document.querySelector('header-drawer details.menu-open, header-drawer details[open]');
      if (!d) return;
      var ust = d.closest('header-drawer').querySelector('#Details-menu-drawer-container > summary');
      setTimeout(function () {
        if (ust && (document.activeElement === document.body || !document.activeElement)) ust.focus();
      }, 450);
    },
    true
  );
})();


/* Tur 142 (akıcılık) — iki "görünmeyen şey boşuna çalışmasın" düzeltmesi:
   1) HERO ÖRTÜLÜYKEN DUR: hero yapışkan (sticky) olduğu için sayfa boyunca
      geometrik olarak hep ekranda; sonraki bölümler üstünü örtüyor. Örtülüyken
      bile 5 sn'de bir slayt değişiyor, her geçişte tüm sayfa yeniden
      hesaplanıyor ve kaydırmada 80–170 ms'lik takılma oluyordu. Sonraki bölümün
      üst kenarı ekranın üstünü geçince hero'ya k-hero-ortulu sınıfı verilir;
      CSS onu çizmez ve animasyonlarını durdurur (karchir-anasayfa.css).
   2) DUYURU ŞERİDİ ekrandan çıkınca döndürme durur, geri gelince devam eder. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  function heroKur() {
    var ic = document.querySelector('.shopify-section > .slideshow-section');
    var bolum = ic && ic.parentElement;
    if (!bolum || getComputedStyle(bolum).position !== 'sticky') return;
    var s = bolum.nextElementSibling;
    while (s && !s.offsetHeight) s = s.nextElementSibling;
    if (!s) return;
    var kok = window.matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
    var kokUst = function () { return kok ? kok.getBoundingClientRect().top : 0; };
    new IntersectionObserver(
      function (k) {
        var e = k[k.length - 1];
        bolum.classList.toggle('k-hero-ortulu', e.boundingClientRect.top < kokUst());
      },
      // Kök aşağıya çok uzatıldı: bağlantıyla sıçramalarda da geri çağrı gelsin.
      // 990px ve üstünde kaydırıcı .page-wrapper olduğu için kök o.
      { root: kok, rootMargin: '0px 0px 100000px 0px', threshold: [0, 1] }
    ).observe(s);
  }

  function duyuruKur() {
    document.querySelectorAll('announcement-bar-component').forEach(function (bar) {
      if (bar.dataset.karchirGozcu) return;
      bar.dataset.karchirGozcu = '1';
      new IntersectionObserver(function (k) {
        if (k[k.length - 1].isIntersecting) {
          if (bar.matches(':focus-within')) return; // klavye odağı içindeyse durmuş kalsın
          if (typeof bar.resume === 'function') bar.resume();
        } else if (typeof bar.suspend === 'function') {
          bar.suspend();
        }
      }).observe(bar);
    });
  }

  // İlk ölçüm yükleme bittikten sonra: açılışta zorunlu düzen olmasın
  function kur() {
    heroKur();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('announcement-bar-component').then(duyuruKur);
    }
  }
  if (document.readyState === 'complete') kur();
  else window.addEventListener('load', kur, { once: true });
})();

/* Tur 142 (akıcılık): oklu hap düğmenin dolgu dairesi artık transform: scale
   ile büyüyor (karchir-tasarim.css). Son yarıçap eski clip-path circle(150%)
   ile aynı olsun diye ölçek, düğmenin boyuna göre İLK hover/odakta bir kez
   hesaplanır: 1,5 × köşegen / √2 / 15px. */
(function () {
  'use strict';
  function olcekYaz(btn) {
    if (!btn || btn.dataset.kOlcek) return;
    var r = btn.getBoundingClientRect();
    if (!r.width) return;
    btn.dataset.kOlcek = '1';
    var yaricap = (1.5 * Math.hypot(r.width, r.height)) / Math.SQRT2;
    btn.style.setProperty('--k-btn-dolgu-olcek', (yaricap / 15).toFixed(2));
  }
  function bul(e) {
    var t = e.target;
    return t && t.closest ? t.closest('.karchir-btn') : null;
  }
  document.addEventListener('pointerover', function (e) { olcekYaz(bul(e)); }, { passive: true });
  document.addEventListener('focusin', function (e) { olcekYaz(bul(e)); });
})();

/* Tur 142b (Batuhan: "üstte kayan kısmı parmağımla da hareket ettirmek
   isterim"): Hakkımızda foto şeridi. Kendiliğinden akış CSS animasyonuyla
   sürüyor (akıcı, GPU'da); parmakla/fareyle yatay sürükleyince animasyon
   durur, şerit parmağı izler, bırakınca biraz süzülür ve kaldığı yerden
   akmaya devam eder. Dikey kaydırma sayfaya kalır (touch-action: pan-y).
   Sürüklemeden sonra karttaki bağlantı açılmaz; kısa dokunuş açılır.
   "Hareketi azalt" açıkken şerit zaten tarayıcının kendi kaydırmasıyla
   kayıyor (karchir-hakkimizda.css); bu kod devreye girmez. */
(function () {
  'use strict';
  var AZALT = window.matchMedia('(prefers-reduced-motion: reduce)');

  function kur(bant) {
    if (bant.dataset.kSurukle) return;
    var ray = bant.querySelector('.karchir-hust__ray');
    if (!ray) return;
    bant.dataset.kSurukle = '1';

    var sure = parseFloat(getComputedStyle(ray).animationDuration) || 108;
    var yarim = 0, x = 0, x0 = 0, basX = 0, basY = 0, id = null;
    var surukluyor = false, hiz = 0, sonX = 0, sonT = 0, kayRaf = 0, tikEngel = false;

    function mevcutX() {
      var m = getComputedStyle(ray).transform;
      if (!m || m === 'none') return 0;
      return new DOMMatrixReadOnly(m).m41;
    }
    // Konumu (-yarım, 0] aralığında tut: iki kopya liste olduğu için sonsuz görünür
    function yaz(v) {
      if (yarim > 0) {
        v = v % yarim;
        if (v > 0) v -= yarim;
      }
      x = v;
      ray.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }
    function durdur() {
      cancelAnimationFrame(kayRaf);
      yarim = ray.getBoundingClientRect().width / 2;
      var v = mevcutX();
      ray.style.animation = 'none';
      yaz(v);
    }
    function devam() {
      var ilerleme = yarim > 0 ? -x / yarim : 0;
      ray.style.transform = '';
      ray.style.animation = '';
      ray.style.animationDelay = -(ilerleme * sure) + 's';
    }

    bant.addEventListener('pointerdown', function (e) {
      if (AZALT.matches) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      id = e.pointerId;
      basX = e.clientX;
      basY = e.clientY;
      surukluyor = false;
    });

    bant.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) return;
      if (e.pointerType === 'mouse' && !(e.buttons & 1)) { id = null; return; } // bırakma kaçtıysa
      var dx = e.clientX - basX;
      var dy = e.clientY - basY;
      if (!surukluyor) {
        if (Math.abs(dx) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { id = null; return; } // dikey: sayfa kaysın
        surukluyor = true;
        durdur();
        x0 = x - dx;
        hiz = 0;
        sonX = e.clientX;
        sonT = e.timeStamp;
        try { bant.setPointerCapture(id); } catch (err) { /* yok say */ }
      }
      yaz(x0 + dx);
      var dt = e.timeStamp - sonT;
      if (dt > 0) hiz = 0.8 * ((e.clientX - sonX) / dt) + 0.2 * hiz;
      sonX = e.clientX;
      sonT = e.timeStamp;
    });

    function birak(e) {
      if (e.pointerId !== id) return;
      id = null;
      if (!surukluyor) return;
      surukluyor = false;
      tikEngel = true;
      setTimeout(function () { tikEngel = false; }, 60);
      // Chrome basılan karta odak veriyor; :focus-within şeridi durdurmasın
      var ak = document.activeElement;
      if (ak && bant.contains(ak) && !ak.matches(':focus-visible')) ak.blur();
      // Bırakınca kısa süzülme, sonra akış kaldığı yerden
      var v = Math.max(-3, Math.min(3, hiz));
      var onceki = performance.now();
      function kay(t) {
        var dt = Math.min(t - onceki, 50);
        onceki = t;
        v *= Math.pow(0.94, dt / 16);
        if (Math.abs(v) < 0.03) { devam(); return; }
        yaz(x + v * dt);
        kayRaf = requestAnimationFrame(kay);
      }
      kayRaf = requestAnimationFrame(kay);
    }
    bant.addEventListener('pointerup', birak);
    bant.addEventListener('pointercancel', birak);

    // Sürüklemenin sonunda karttaki bağlantı açılmasın
    bant.addEventListener('click', function (e) {
      if (tikEngel) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // Masaüstünde fareyle sürüklerken görsel/bağlantı "sürükle-bırak" başlamasın
    bant.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function hepsi() { document.querySelectorAll('.karchir-hust__bant').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi);
  else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
